import { render, staticRenderFns } from "./forgot_password_component.vue?vue&type=template&id=f69e8170&scoped=true&"
import script from "../../assets/customer/js/forgot_password.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/forgot_password.js?vue&type=script&lang=js&"
import style0 from "./forgot_password_component.vue?vue&type=style&index=0&id=f69e8170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69e8170",
  null
  
)

export default component.exports